module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"see_more":"더보기","see_all":"모든 리뷰 보기"}}')
  delete Component.options._Ctor
}
